import { ApolloClient, ApolloProvider, concat, HttpLink, InMemoryCache } from '@apollo/client';
import { setContext } from '@apollo/client/link/context';
import { getAuthorizationToken } from 'modules/auth/useAuth';
import { FC, PropsWithChildren } from 'react';
import { appConfig } from 'shared/appConfig';

const createApolloClient = () => {
  const httpLink = new HttpLink({
    uri: appConfig.gqlApiUrl,
  });

  return new ApolloClient({
    uri: appConfig.gqlApiUrl,
    cache: new InMemoryCache(),
    link: concat(
      setContext(async (context) => {
        const authorizationToken = await getAuthorizationToken();

        if (!authorizationToken) {
          return {
            ...context,
            headers: {
              'target-service': 'hub-api',
            },
          };
        }

        return {
          ...context,
          uri: `${appConfig.gqlApiUrl}?operation=${context.operationName}`,
          headers: {
            authorization: `Bearer ${authorizationToken}`,
            'target-service': 'hub-api',
          },
        };
      }),
      httpLink,
    ),
  });
};

const client = createApolloClient();
export const GraphqlProvider: FC<PropsWithChildren> = ({ children }) => {
  return <ApolloProvider client={client}>{children}</ApolloProvider>;
};
